module.exports = __webpack_public_path__ + "h5/img/back_end2.f669f226.png";